import './assets/css/app.less'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

import './permission.js'
const app = createApp(App)

// ant 配置
import "@/config/ant-config";

// 添加全局方法
import { Filter } from './utils/filter'
app.use(Filter);

app.config.warnHandler = () => null;

app.use(createPinia())
app.use(router)
app.mount('#app')
